export interface IMonthlyMortgagePaymentOptions {
  price: number | string;
  firstInstallmentInPercent: number | string;
  rate: number | string;
  months: number | string;
}

export function getMonthlyMortgagePayment(options: IMonthlyMortgagePaymentOptions) {
  let {
    price,
    firstInstallmentInPercent,
    rate,
    months,
  } = options;

  if (typeof price === 'string') {
    price = parseInt(price.replace(/\D/g, ''), 10);
  }
  if (typeof firstInstallmentInPercent === 'string') {
    firstInstallmentInPercent = parseFloat(firstInstallmentInPercent.replace(',', '.'));
  }
  if (typeof rate === 'string') {
    rate = parseFloat(rate.replace(',', '.'));
  }
  if (typeof months === 'string') {
    months = parseInt(months, 10);
  }

  // tslint:disable-next-line:max-line-length
  return Math.round(((1 - firstInstallmentInPercent / 100) * price * (rate / 12 / 100)) / (1 - Math.pow(1 + firstInstallmentInPercent / 12 / 100, -months)));
}
